import PropTypes from 'prop-types';
import React from 'react';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { Button } from 'react-bootstrap';

const CarouselButton = ({ direction, clickEvent, mouseUpEvent, classes }) => {
	const labels = useLabels();
	const text =
		direction === 'right'
			? labels.get('NEXT_PHOTO')
			: labels.get('PREVIOUS_PHOTO');

	return (
		<Button
			className={setClassNames(['btn-carousel', 'd-none', ...classes])}
			onClick={clickEvent}
			onMouseUp={mouseUpEvent}
			bsStyle={null}
			title={text}
		>
			<i
				role="presentation"
				aria-hidden="true"
				className={setClassNames([
					'ddc-icon',
					'ddc-icon-carousel-arrow',
					`ddc-icon-carousel-arrow-${direction}`,
					'icon-dimension-size-3',
					'd-block'
				])}
			/>
			<span className="sr-only">{text}</span>
		</Button>
	);
};

CarouselButton.propTypes = {
	direction: PropTypes.string.isRequired,
	clickEvent: PropTypes.func.isRequired,
	mouseUpEvent: PropTypes.func,
	classes: PropTypes.arrayOf(PropTypes.string)
};

CarouselButton.defaultProps = {
	mouseUpEvent: () => null,
	classes: []
};

export default CarouselButton;
